export default __webpack_public_path__ + "static/media/valet-parking.inline.68f8c463.svg";